import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './Notes.css';
import Input from '../../../components/UI/Input/Input';
import { updateObject, checkValidity } from '../../../shared/utility';

class Notes extends Component {
    state = {
        orderForm: {
            notes: {
                label: 'Special Instructions',
                elementType: 'textarea',
                elementConfig: {
                    type: 'text',
                    placeholder: 'Placement Instructions...'
                },
                value: '',
                validation: {
                    required: false,                    
                },
                valid: true,
                touched: false
            }
        },
        formIsValid: false
    }

    orderHandler = ( event ) => {
        event.preventDefault();

        
    }

    inputChangedHandler = (event, inputIdentifier) => {
        let valid = checkValidity(event.target.value, this.state.orderForm[inputIdentifier].validation)
        const updatedFormElement = updateObject(this.state.orderForm[inputIdentifier], {
            value: event.target.value,
            valid: valid,
            touched: true
        });
        const updatedOrderForm = updateObject(this.state.orderForm, {
            [inputIdentifier]: updatedFormElement
        });
        
        let formIsValid = true;
        for (let inputIdentifier in updatedOrderForm) {
            formIsValid = updatedOrderForm[inputIdentifier].valid && formIsValid;
        }
        this.setState({orderForm: updatedOrderForm, formIsValid: formIsValid});

        if (valid)
        {
            this.props.onDataChanged(inputIdentifier,event.target.value);
        }
    }

    render () {
        const formElementsArray = [];
        for (let key in this.state.orderForm) {
            formElementsArray.push({
                id: key,
                config: this.state.orderForm[key]
            });
        }
        let form = (
            <form onSubmit={this.orderHandler}>
                {formElementsArray.map(formElement => (
                    <Input 
                        key={formElement.id}
                        label={formElement.config.label}
                        elementType={formElement.config.elementType}
                        elementConfig={formElement.config.elementConfig}
                        value={this.props[formElement.id]}
                        invalid={!formElement.config.valid}
                        shouldValidate={formElement.config.validation}
                        touched={formElement.config.touched}
                        changed={(event) => this.inputChangedHandler(event, formElement.id)} />
                ))}
            </form>
        );
        
        return (
            <div className={classes.Notes}>
                {form}
            </div>
        );
    }
};

const mapStateToProps = state => {
 
    return {
        notes: state.orders.order.notes
    };
}


export default connect(mapStateToProps)(Notes);


// WEBPACK FOOTER //
// ./src/components/Order/Notes/Notes.js